export default __webpack_public_path__ + "static/media/listMoreIcon.1f74f0fe.svg";